<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" size="lg-fix-h" :ariaLabel="header">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" :disabled="isGeneralLoading"/>
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 45vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2">
            <div ref="valueTo">

              <accessible-el-select
                prop="valueTo"
                v-model="form.valueTo"
                isMultiple
                allowCreate
                maxlength='100'
                placeholder="Seleccionar"
                :options="form.ListaBlancaEmails.map((x, index) => ({ id: index, value: x, name: x }))"
                id-prefix="inputtextmailfromwhitelist"
              >
                <template #label>
                  <div class="flex items-center">
                    {{$t('app.mail_para')}}
                    <base-tooltip-icon size="sm" :section="$t('app.mail_para')" :content="'Seleccione emails de la lista o escriba un nuevo email y selecciónelo'" class="ml-2"/>
                  </div>
                </template>
              </accessible-el-select>

            </div>
          </div>
          <div class="lg:mb-2">
            <div ref="valueCC">

              <accessible-el-select
                prop="valueCC"
                v-model="form.valueCC"
                isMultiple
                allowCreate
                maxlength='100'
                placeholder="Seleccionar"
                :options="form.ListaBlancaEmails.map((x, index) => ({ id: index, value: x, name: x }))"
                id-prefix="inputtextmailfromwhitelist"
              >
                <template #label>
                  <div class="flex items-center">
                    {{$t('app.mail_cc')}}
                    <base-tooltip-icon size="sm" :section="$t('app.mail_cc')" :content="'Seleccione emails de la lista o escriba un nuevo email y selecciónelo'" class="ml-2"/>
                  </div>
                </template>
              </accessible-el-select>

            </div>
          </div>
          <div class="lg:mb-2">
            <div ref="valueCCO">

              <accessible-el-select
                prop="valueCCO"
                v-model="form.valueCCO"
                isMultiple
                allowCreate
                maxlength='100'
                placeholder="Seleccionar"
                :options="form.ListaBlancaEmails.map((x, index) => ({ id: index, value: x, name: x }))"
                id-prefix="inputtextmailfromwhitelist"
              >
                <template #label>
                  <div class="flex items-center">
                    {{$t('app.mail_cco')}}
                    <base-tooltip-icon size="sm" :section="$t('app.mail_cco')" :content="'Seleccione emails de la lista o escriba un nuevo email y selecciónelo'" class="ml-2"/>
                  </div>
                </template>
              </accessible-el-select>
              
            </div>
          </div>
          <div class="lg:mb-2" v-if="hasModuleCustomMails">
            <div ref="AsuntoCorreo">
              <div class="flex items-center mb-1">
                <span id="input-text-mail-whitelist-asunto-label" class="text-sm font-semibold text-secondary-600 block">{{$t('app.AsuntoCorreo')}}</span>                
              </div>
                <el-form-item prop="AsuntoCorreo">
                  <el-input
                      class="w-full"
                      v-model="form.AsuntoCorreo"
                      maxlength='255'
                      aria-labelledby="input-text-mail-whitelist-asunto-label"
                    >
                    <template v-if="form.AsuntoCorreo" slot="suffix">
                      <base-clear-input-button
                        aria-label="Limpiar campo de asunto del correo"
                        @clear="form.AsuntoCorreo = ''"
                      />
                    </template>
                  </el-input>
                </el-form-item>
            </div>
            <div ref="TextoCorreo">
              <div class="flex items-center mb-1">
                <span id="input-text-mail-whitelist-texto-label" class="text-sm font-semibold text-secondary-600 block">{{$t('app.TextoCorreo')}}</span>
                <base-tooltip-icon size="sm" :section="$t('app.TextoCorreo')" :content="$t('tooltip.texto_correo')" class="ml-2"/>
              </div>
                <el-form-item prop="TextoCorreo">
                  <el-input
                    type="textarea"
                    :rows="2"
                    class="w-full"
                    aria-labelledby="input-text-mail-whitelist-texto-label"
                    v-model="form.TextoCorreo"
                    maxlength="1000"
                    >
                    <template v-if="form.TextoCorreo" slot="suffix">
                      <base-clear-input-button
                        aria-label="Limpiar campo de texto del correo"
                        @clear="form.TextoCorreo = ''"
                      />
                    </template>
                  </el-input>
                </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')" :disabled="isGeneralLoading" :loading="isGeneralLoading"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')" :disabled="isGeneralLoading || notSelectedMail" :loading="isGeneralLoading"/>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
import { email as emailRegex } from '@/utils/regex'
import { getWhiteListEmailsMix } from '@/services/clients/lists/getWhiteListEmailsMix'

import BaseDialogButton from './base/BaseDialogButton.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'input-text-mail-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect,
  },
  props: {
    header: {
      type: String,
      default: 'Importante'
    },
    headerValue: {
      type: String,
      default: 'Valor'
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    idCliente: {
      type: [Number, String],
      default: -1
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        valueTo: '',
        valueCC: '',
        valueCCO: '',
        TextoCorreo: '',
        AsuntoCorreo: '',
        GestionarListaBlancaGrupos: false,
        ListaBlancaEmails: [],
      },
      rules: {
        valueTo: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        valueCC: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        valueCCO: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.form.valueTo = ''
      this.form.valueCC = ''
      this.form.valueCCO = ''
      this.form.TextoCorreo = ''
      this.form.AsuntoCorreo = ''
      this.form.GestionarListaBlancaGrupos = false
      if (value) this.downloadListwhiteEmail()
    }
  },
  mounted: async function () {
  },
  computed: {
    hasModuleCustomMails () {
      return this.$store.getters['auth/hasModuleCustomMails']
    },
    notSelectedMail () {
      return (!this.form.valueTo || this.form.valueTo.length === 0) && 
      (!this.form.valueCC || this.form.valueCC.length === 0) && 
      (!this.form.valueCCO || this.form.valueCCO.length === 0)
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role'].toLowerCase()
    }
  },
  methods: {
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: async function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', this.form)
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
    },
    isEmailValid: function (rule, value, callback) {
      if (!value || value.length === 0) {
        return callback()
      }
      let flag = false
      value.forEach(x => {
        if (!emailRegex.test(x)) {
          this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
          flag = true
        }
      })
      if (!flag) callback()
    },
    downloadListwhiteEmail: async function () {
      try {
        const result = await getWhiteListEmailsMix({ idCliente: this.idCliente })
        if (result.blnError === true) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.form.ListaBlancaEmails = result.Emails
          this.form.GestionarListaBlancaGrupos = result.GestionarListaBlancaGrupos
        }
      } catch (error) {
        this.doFeedback()
      } finally {
      }
    },
  }
}
</script>
